export const PARTNERS_PAGE_PATH = "/shipper/partners";
export const CARRIER_INTEGRATIONS_PAGE_PATH = "/shipper/carriers";
